import apiClient from '../api';

export const studentService = {
    getDashboard: () => apiClient.get('/students/me/dashboard'),
    getSchedule: () => apiClient.get('/students/me/schedule'),
    getDocuments: () => apiClient.get('/students/me/documents'),
    getWeekReadingMaterial: (weekNumber: number) => apiClient.get(`/students/me/reading-material/${weekNumber}`),
    getProfile: () => apiClient.get('/students/me/profile'),
    updateProfile: (data: any) => apiClient.put('/students/me/profile', data),
    verifyProfileSection: (section: 'basic_details' | 'school_contact' | 'academic_profile') =>
        apiClient.patch('/students/me/profile/verify-section', { section }),
    uploadProfilePicture: (formData: FormData) => apiClient.post('/students/me/profile-picture', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }),
    deleteProfilePicture: () => apiClient.delete('/students/me/profile-picture'),
    uploadProjectPresentation: (formData: FormData) => apiClient.post('/students/me/project-presentation', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }),
    deleteProjectPresentation: () => apiClient.delete('/students/me/project-presentation'),
    uploadProjectScreenshot: (formData: FormData) => apiClient.post('/students/me/project-screenshot', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }),
    deleteProjectScreenshot: () => apiClient.delete('/students/me/project-screenshot'),
    getSkillProfile: () => apiClient.get('/students/me/skill-profile'),
    getLinkedInPost: () => apiClient.get('/students/me/skill-profile/linkedin-post'),
    generateLinkedInPost: () => apiClient.post('/students/me/skill-profile/generate-linkedin-post'),
};
